  <template>
      <DashboardLayout>

          <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
              <p class="mb-0 main-identifier fw-semibold">MDA</p>
              <span class="material-symbols-outlined">keyboard_arrow_right</span>
              <p class="mb-0 sub-identifier">Create Sub-sector</p>
          </div>

          <div class="d-flex justify-content-center">
              <div class="form-outer">
                  <form @submit.prevent="handleSubmit">
                      <div class="crud-form position-relative">

                          <div class="form-inner">
                              <div class="form-header d-flex justify-content-between align-items-center">
                                  <h1 class="mb-0">Sub-sector</h1>
                              </div>

                            <div class="form-body">
                              <div class="row mt-2 mb-3">
                              <div class="col-md-12 row form-group position-relative floating-label-group">
                                <div class="col-md-2 label-left d-flex justify-content-end align-items-center"><label for="sector" class="form-label">Sector</label></div>
                                <div class="col-md-10 input-right">
                                  <select class="form-select" v-model="sectorId" @change="checkAddNewSector" required>
                                      <option value="" disabled>- Select Sector -</option>
                                      <option v-for="sec in sectors" :key="sec.id" :value="sec.id">{{ sec.description }}</option>
                                  </select>
                                </div>
                              </div>

                              <div class="col-md-12 row form-group position-relative floating-label-group">
                                <div class="col-md-2 label-left d-flex justify-content-end align-items-center"><label for="name" class="form-label">Sub-sector Code</label></div>
                                <div class="col-md-10 input-right"><input type="text" class="form-control" v-model="subSectorCode" placeholder="Enter Sub-sector Code" required></div>
                              </div>

                              <div class="col-md-12 row form-group position-relative floating-label-group">
                                <div class="col-md-2 label-left d-flex justify-content-end align-items-center"><label for="description" class="form-label">Description</label></div>
                                <div class="col-md-10 input-right">
                                  <textarea
                                    class="form-control"
                                    id="description"
                                    v-model="description"
                                    placeholder=""
                                    rows="3"
                                    required
                                  ></textarea>
                                </div>
                              </div>

                              <div class="d-flex justify-content-center">
                                <button class="submit-btn" type="submit" :disabled="isLoading">
                                    <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    {{ isLoading ? 'Submitting...' : 'Submit' }}
                                </button>
                            </div>
                          </div>
                      </div>
                      </div>
                      </div>
                  </form>
              </div>
          </div>

      </DashboardLayout>
  </template>

  <script setup>
  import { ref, onMounted } from 'vue'
  import axios from 'axios'
  import DashboardLayout from '../layout/DashboardLayout.vue'
  import Cookies from 'js-cookie';
  import Swal from 'sweetalert2'

  const sectorId = ref('');
  const subSectorCode = ref('');
  const description = ref('');

  const root_api_url = process.env.VUE_APP_API_ROOT_URL

  const isLoading = ref(false);


  const sectors = ref([])

  const fetchSectors = async () => {
      const token = Cookies.get('auth_token');
    try {
      const response = await axios.get(`${root_api_url}/eli/sector`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      //roles.value = response.data

      sectors.value = response.data.map(sector => ({
        id: sector.id,
        description: sector.description
      })).sort((a, b) => a.description.localeCompare(b.description))
    } catch (error) {
      console.error('Failed to fetch sectors:', error)
    }
  }

  const handleSubmit = async () => {

    const token = Cookies.get('auth_token');

    isLoading.value = true;

    const SubSectorData = {
      sectorId: sectorId.value.trim(),
      subSectorCode: subSectorCode.value.trim(),
      description: description.value.trim(),
    };
    // console.log('SubSectorData:', SubSectorData)

    const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
    const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

    try {

      const result = await axios.post(`${root_api_url}/eli/sub-sector`, SubSectorData, {
          headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          },
      });

      if (result.status === 201) {
        Swal.fire({
          // title: 'Success!',
          html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Sub-sector Created Successfully</p> `,
          showConfirmButton: true,
          showCloseButton: true,
          icon: undefined,
        });
        description.value = ''
        sectorId.value = ''
        subSectorCode.value = ''
      }
    } catch (error) {
      // Swal.fire({
      //   html: `${iconHtmlError}
      //   <h1 style="font-weight:600;">Error</h1>
      //   <p>$Failed to create Sub-sector</p>`,
      //   showConfirmButton: true,
      //   showCloseButton: true,
      //   icon: undefined,
      // });

      console.log(error)

      if (error.response) {
        Swal.fire({
          html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>${error?.response?.data?.errorMessage || error?.response?.data?.error || 'Unexpected error occurred while creating sub-sector. Kindly contact administrator'}</p>`,
          showConfirmButton: true,
          showCloseButton: true,
          icon: undefined,
        });
      } else {
        Swal.fire({
          html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>Unexpected error occurred while creating sub-sector. Kindly contact administrator</p>`,
          showConfirmButton: true,
          showCloseButton: true,
          icon: undefined,
        });
      }


    } finally {
        isLoading.value = false;
    }
  }

  // On mount, load sectors and subsectors
  onMounted(() => {
    fetchSectors(),
    document.title = "Create Sub-sectors"
  })
  </script>
